import { createJSONRequest } from './create-request'

export const getLinkPreview = (url) => createJSONRequest({
  url: `/api/link-preview?url=${encodeURIComponent(url)}`,
  method: 'GET',
})

// Our own file URLs stream bytes and can't be unfurled like an external page,
// so they have a dedicated metadata endpoint returning the same shape.
export const getActorFilePreview = (actorId, fileId) => createJSONRequest({
  url: `/api/actors/${actorId}/files/${fileId}/meta`,
  method: 'GET',
})
